export default "__VITE_ASSET__Rt0R_vtB__"